import React from 'react';
import ModalImage from "react-modal-image";



const ImageCollectionHorizontal = ({imgDir, count}) => {
const imageList = [... new Array(count)].map((Number, index)=> `/images/${imgDir}/${index+1}.JPG`);


  return (
    <>
    <ul className='image-collection-container'>{
        imageList.map((imgUrl, index) => {
           return (
            <li className='item' >
                <figure>

                <ModalImage className='modal-image'
                    small={imgUrl}
                    large={imgUrl}
                    alt=""/>      

                </figure> 
            </li>
           );
        })
        
        
        }
        
    </ul>
    
    </>
  );
};

export default ImageCollectionHorizontal